module.exports = __webpack_public_path__ + "media/images/lb/748-48dca3d3336d3242a0e511e5e3424da5.svg";